/* Luvlyn · de plakbalk onderaan (sections/luvlyn-plakbalk.liquid). Sinds 05-10-2026 een eigen bestand: de balk
   werkt op elk sjabloon, ook zonder product.js en zonder koopblok (audit; daarvoor product.js, onderdeel 4).
   - Staat er een koopknop met [data-plak-anker] op de pagina (het koopblok op de productpagina), dan verschijnt
     de balk zodra die knop boven uit beeld is. Zo was het, en zo blijft het.
   - Anders verschijnt hij als je ongeveer een scherm gescrold bent, en wijkt hij zolang er een andere
     koopknop ([data-in-mand]) in beeld is: dan staan er geen twee knoppen tegelijk.
   - Altijd weg zodra de voet in beeld komt. body.met-plak schuift de toast en de speler omhoog (plakbalk.css).
   In het mandje leggen doet assets/site.js (data-in-mand, data-open-mandje); de kleur volgen product.js. */
(() => {
  const balk = document.querySelector('[data-plak]');
  if (!balk || balk.hasAttribute('data-plak-klaar')) return;
  balk.setAttribute('data-plak-klaar', '');
  const voet = document.querySelector('.sectie[data-id="voet"]');
  const anker = document.querySelector('[data-plak-anker]');
  let ankerBoven = false, ver = false, voetZicht = false;
  const knoppenInBeeld = new Set();
  function werkBij(){
    const aan = (anker ? ankerBoven : ver && !knoppenInBeeld.size) && !voetZicht;
    if (aan === balk.classList.contains('aan')) return;
    balk.classList.toggle('aan', aan);
    document.body.classList.toggle('met-plak', aan);
  }
  if (anker) {
    // het kijkvenster loopt ver naar beneden door, zodat ook een sprong voorbij de knop (een link naar
    // #reviews) telt: een gewone IntersectionObserver merkt zo'n sprong niet (ontwerp, 01-10).
    new IntersectionObserver(([e]) => { ankerBoven = !e.isIntersecting && e.boundingClientRect.top < 0; werkBij(); }, { rootMargin: '0px 0px 100000px 0px' }).observe(anker);
  } else {
    const kijk = () => { const nu = scrollY > innerHeight * .9; if (nu !== ver) { ver = nu; werkBij(); } };
    addEventListener('scroll', kijk, { passive: true });
    kijk();
    const io = new IntersectionObserver(es => { es.forEach(e => (e.isIntersecting ? knoppenInBeeld.add(e.target) : knoppenInBeeld.delete(e.target))); werkBij(); });
    document.querySelectorAll('[data-in-mand]').forEach(k => { if (!balk.contains(k)) io.observe(k); });
  }
  if (voet) new IntersectionObserver(([e]) => { voetZicht = e.isIntersecting; werkBij(); }).observe(voet);
})();
